import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

// store
import { useStoreValue } from '../../../../../../store';

// components
import PlusIcon from '../../../../../../icons/PlusIcon';
import MagicAiIcon from '../../../../../../icons/MagicAiIcon';
import ModalUploadSimple from '../../../../../../components/ModalUploadSimple';
import ModalUploadCueSheetWithClip from '../../../../../../components/ModalUploadCueSheetWithClip';
import ListOfReferenceItems from '../MusicList/components/ListOfReferenceItems';
import ListOfSoundtrackItems from './components/ListOfSoundtrackItems';
import ModalGeneratePrompt from '../../../../../../components/ModalGeneratePrompt';

const MusicList = () => {
    const { projectId } = useParams();
    const myStudioLeftPanel = useStoreValue('myStudioLeftPanel');
    const myStudioMusicPanel = useStoreValue('myStudioMusicPanel');
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [showGenerateModal, setShowGenerateModal] = useState(false);

    return (
        myStudioLeftPanel === 'music'
            ? <>
                <OverlayScrollbarsComponent element="div" options={{ scrollbars: { autoHide: 'never' } }} defer>
                    <ul className="timelineEditorAuxControls__listOfTracks">
                        {myStudioMusicPanel === 'references'
                            ? <ListOfReferenceItems/> : null}
                        {myStudioMusicPanel === 'soundtrack'
                            ? <ListOfSoundtrackItems/> : null}
                    </ul>
                </OverlayScrollbarsComponent>
                <button className="timelineEditorAuxControls__addNew" onClick={() => setShowUploadModal(true)}>
                    <PlusIcon/>
                </button>
                <button className="timelineEditorAuxControls__addNew" title="Genera musica da testo" onClick={() => setShowGenerateModal(true)}>
                    <MagicAiIcon/>
                </button>
                <ModalGeneratePrompt
                    visible={showGenerateModal}
                    projectId={projectId}
                    onHide={() => setShowGenerateModal(false)}
                />
                {showUploadModal && myStudioMusicPanel === 'references' && (
                    <ModalUploadSimple
                        projectId={projectId}
                        type="references"
                        headerText="Carica Reference"
                        onClose={() => setShowUploadModal(false)}
                    />
                )}
                {showUploadModal && myStudioMusicPanel === 'soundtrack' && (
                    <ModalUploadCueSheetWithClip
                        projectId={projectId}
                        cueType="MUSIC"
                        headerText="Carica Soundtrack"
                        onClose={() => setShowUploadModal(false)}
                    />
                )}
            </> : null
    );
};

export default MusicList;
